import config from '../../config/config';

import getRequest from './base/get';
import postRequest from './base/post';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

export default {
  /**
   * Run campaign
   * @param {any} data - The data
   */
  runCampaign: (data: any): Promise<any> => {
    const parameters = { ...data };
    return postRequest(
      `${config.subscription.accountApiUrl}api/super-admin/v1/campaign/reset-password`,
      parameters,
    );
  },

  /**
   * Fetch the Accounts list
   * @param {any} query - The query
   */
  fetchAccounts: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.subscription.accountApiUrl}api/super-admin/v1/campaign/get-accounts`, {
      ...parameters,
    });
  },

  /**
   * Fetch the templates list
   * @param {any} query - The query
   */
  fetchTemplates: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.subscription.accountApiUrl}api/super-admin/v1/campaign/templates`, {
      ...parameters,
    });
  },

  /**
   * Fetch the campaigns
   * @param {any} query - The query
   */
  fetchCampaigns: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.subscription.accountApiUrl}api/super-admin/v1/campaign/reset-password`, {
      ...parameters,
    });
  },

  /**
   * Fetch the single campaign
   * @param {any} id - The id
   */
  fetchSingleCampaign: (id: string): Promise<any> => {
    return getRequest(`${config.subscription.accountApiUrl}api/super-admin/v1/campaign/reset-password/${id}`);
  },
};
